// One Markdown parser for the whole app (SPEC §7): remark + GFM, with positions.
import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import type { Root, Nodes, Parents } from 'mdast';

const processor = unified().use(remarkParse).use(remarkGfm);

export function parseMarkdown(md: string): Root {
  return processor.parse(md);
}

export const startOf = (n: Nodes) => n.position!.start.offset!;
export const endOf = (n: Nodes) => n.position!.end.offset!;

export function* walk(node: Nodes, depth = 0, parent?: Parents): Generator<{ node: Nodes; parent: Parents | undefined; depth: number }> {
  yield { node, parent, depth };
  if ('children' in node) for (const c of node.children as Nodes[]) yield* walk(c, depth + 1, node as Parents);
}
